import React from 'react';
import { useDispatch } from 'react-redux';

import { dashboardClienteAction } from "components/ApplicationInsights/eventNames";
import TrackingOrderSlider from 'components/TrackingOrderSlider';
import { MenuItem } from "..";

import trackingOrder from 'img/menu-icon-tracking-order.svg';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './styles.scss';

import { IMenuItem } from '../interface';

interface IProps {
  itemComponent: React.FC<IMenuItem>,
  clickAction?: Function;
}

const TrackingOrder: React.FC<IProps> = (props: IProps) => {
  const { itemComponent, clickAction } = props;

  const dispatch = useDispatch();

  const defaultClickAction = () => {
    dispatch({
      type: 'OPEN_SLIDER',
      data: {
        title: 'Tracking do Pedido',
        subtitle:
          'Utilize os campos abaixo para localizar o seu pedido.',
        show: true,
        content: TrackingOrderSlider,
      },
    });
  };

  return React.createElement(itemComponent, {
    title: "TRACKING",
    subtitle: "DO PEDIDO",
    icon: trackingOrder,
    trackName: dashboardClienteAction.DASHCLIENTE_TRACKINGPEDIDO,
    onClick: () => clickAction ? clickAction() : defaultClickAction(),
    id: "tracking-order-menu-item"
  });
};

export default TrackingOrder;